/**
 * Tutorial step definitions for driver.js.
 * Targets use data-tutorial-id attributes on existing UI elements.
 */
export const TUTORIAL_STEP_IDS = {
  WELCOME: "tutorial-welcome",
  NAV_TABS: "tutorial-nav-tabs",
  LIVE_QUE: "tutorial-live-que",
  STATS: "tutorial-stats",
  SETTINGS: "tutorial-settings",
  HELP: "tutorial-help",
  CONTENT: "tutorial-content",
};

/**
 * Steps in driver.js DriveStep format.
 * @see https://driverjs.com/docs/configuration
 */
const TUTORIAL_STEPS = [
  {
    element: "body",
    popover: {
      title: "Welcome",
      description:
        "This short tour highlights the main areas. You can skip or close anytime.",
      side: "over",
      align: "center",
    },
  },
  {
    element: `[data-tutorial-id="${TUTORIAL_STEP_IDS.NAV_TABS}"]`,
    popover: {
      title: "Navigation",
      description:
        "Use these tabs to switch between Live Queue, Stats, Report, and Settings.",
      side: "bottom",
      align: "center",
    },
  },
  {
    element: `[data-tutorial-id="${TUTORIAL_STEP_IDS.LIVE_QUE}"]`,
    popover: {
      title: "Live Queue",
      description:
        "Open the live queue to see and manage waiting customers in real time.",
      side: "bottom",
      align: "center",
    },
  },
  {
    element: `[data-tutorial-id="${TUTORIAL_STEP_IDS.STATS}"]`,
    popover: {
      title: "Stats",
      description: "View your dashboard and statistics here.",
      side: "bottom",
      align: "center",
    },
  },
  {
    element: `[data-tutorial-id="${TUTORIAL_STEP_IDS.SETTINGS}"]`,
    popover: {
      title: "Settings",
      description:
        "Configure Services, Menu, and other settings from this dropdown.",
      side: "bottom",
      align: "center",
    },
  },
  {
    element: `[data-tutorial-id="${TUTORIAL_STEP_IDS.HELP}"]`,
    popover: {
      title: "Help",
      description:
        "You can restart this tutorial anytime from the help icon.",
      side: "bottom",
      align: "center",
    },
  },
];

export const getTutorialSteps = () => TUTORIAL_STEPS;
